import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { menuCloseIcon, chervonRightIcon, dashboard, apprenticeIcon, archiveIcon, documentIcon, bellIcon, calendarsIcon, settingsIcon, globeIcon, logoutIcon, moonIcon, chatIcon, laptopIcon, calendarIcon, vCopyIcon, bundleBoxIcon, userIcon, coursesIcon, homeIcon } from "../constants/icons";
import CircleImage from 'olive-react-myoneui/lib/CircleImage';
import Button from "olive-react-myoneui/lib/Button";
import { useTranslation } from "react-i18next";
import OffcanvasNotification from "./student-dashboard/OffcanvasNotificaton";
import OffcanvasMessages from "./student-dashboard/OffcanvasMessages";
import { getNotificationCount } from "../../api/afterLogin/notification";
import { getMessageCount } from "../../api/afterLogin/setting";
import { convertUTCtoLocalTime } from "../../helpers/datetime_helper";
import { readCookie } from "../../utils/cookie";
import Skeleton from 'react-loading-skeleton'
import { Form } from "olive-react-myoneui";
import { availableLanguages } from "../../constants/config";
import { setLangInCache } from "../../utils/helpers";
import { clearSPAuthTokens } from "../../helpers/spauth_token_helper";

function OffcanvasNavMenu({ className }) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [menuActive, setMenuActive] = useState(false);
  const [colorScheme, setColorScheme] = useState("light");
  const adminData = useSelector((state) => state.admin);
  const loggedInUser = useSelector((state) => state.user.user);
	const paths = useSelector((state) => state.user.paths);
  const configData    = useSelector((state) => state.config);
  const userSpEnabled = adminData.user_sp_enabled;

  const [showCourses, setShowCourses]                 = useState(false);
  const [showTms, setShowTms]                         = useState(false);
  const [showDocumentManager, setShowDocumentManager] = useState(false);
  const [showApprenticeship, setShowApprenticeship]   = useState(false);
  const [showMyConnect, setShowMyConnect]             = useState(false);
  const [myConnectUrl, setMyConnectUrl]               = useState('');
  const [renderLogo, setRenderLogo]                   = useState();

  const [notificationCount, setNotificationCount] = useState();
  const [messageCount, setMessageCount] = useState(null);
  const preview_as_user = readCookie("preview_as_user");

  const header       = adminData.header;
  const appProducts  = adminData.products;
  const planFeatures = adminData.features;
  const timezone     = adminData.us_timezone;
  const ePortfolio   = appProducts && appProducts?.find((product)=> product.name == "E-portfolio");

  
  /* PROFILE */
  let profileImage;
  if (header && header.us_image_url) {
    profileImage = <img src={header.us_image_url} width="150" alt="Profile" />;
  } else if (adminData.us_name) {
    profileImage = adminData.us_name[0];
  }

  

  const onHamburgerClick = () => {
    const body = document.body;
    if (body.classList.contains("menu-active")) {
      body.classList.remove("menu-active");
      setMenuActive(false);
    } else {
      body.classList.add("menu-active");
      setMenuActive(true);
    }
  };

  const fetchMessageCount = async () => {
    const params = {
      host: paths.message_api_url,
      userId: loggedInUser.logged_in_user.id,
      accessToken: loggedInUser.logged_in_user.token
    }
    const response = await getMessageCount(params);
    if (response) {
      setMessageCount(response?.data?.count)
    }
  }
  
  const fetchNotificationCount = async () => {
    if (loggedInUser.is_logged_in) {
      const host = window.location.hostname
      const params = {
        host: host,
        user: loggedInUser.is_logged_in
      }
      const response = await getNotificationCount(params);
      if (response) {
        setNotificationCount(response.data.count)
      }
    }
  }

  const isNotExpired = (expiryDate) => {
    return new Date(expiryDate) > new Date(); // Check if expiry date is in the future
  };
  
  const userSpEnabledOverride = (productId) => {
    const foundProduct = userSpEnabled && userSpEnabled.length > 0 ? userSpEnabled.find((userSp) => productId == userSp.uspa_sp_id) : false;
    if (foundProduct && foundProduct.uspa_sp_enabled === '1') {
      return true;
    }
    return false;
  };

  useEffect(() => {
    try {
      const savedColorScheme = localStorage.getItem("color-scheme");
      if (savedColorScheme) {
        setColorScheme(savedColorScheme);
        document.documentElement.setAttribute("data-color-mode", savedColorScheme);
      }
      fetchMessageCount();
      fetchNotificationCount();
      setRenderLogo(header.logo)
    } catch (e) {
      console.error(e);
    }
  }, [loggedInUser.is_logged_in, header.logo]);

  useEffect(() => {
    if(appProducts && appProducts?.length > 0) {
      appProducts?.map((product, key) => {
        const sessionRoleId          = configData?.session?.us_role_id ?? null;
        const isAllowed              = userSpEnabledOverride(product.id);
        const isRolesDisabled        = (sessionRoleId  !== null && product?.sp_disabled_roles && product?.sp_disabled_roles !== null) ? 
                                       product?.sp_disabled_roles.includes(sessionRoleId) : false;
        const isRoleDisabledOverride = !isAllowed && !isRolesDisabled ? true  :
                                        isAllowed && !isRolesDisabled ? true  : 
                                        isAllowed && isRolesDisabled  ? true  : 
                                       !isAllowed && isRolesDisabled  ? false : true;
        
        if (product.sp_uid == 'mykademy' &&  isNotExpired(product.expiry_date)) {
            setShowCourses(isRoleDisabledOverride);
        }
        if (product.sp_uid == 'tms' && isNotExpired(product.expiry_date)) {
          setShowTms(isRoleDisabledOverride);
        }
        if (product.sp_uid == 'dms' && isNotExpired(product.expiry_date)) {
          setShowDocumentManager(isRoleDisabledOverride);
        }
        if (product.sp_uid == 'eportfolio' && isNotExpired(product.expiry_date)) {
          setShowApprenticeship(isRoleDisabledOverride);
        }
        if(product.sp_uid == 'myconnect' && isNotExpired(product.expiry_date)) {
          setShowMyConnect(isRoleDisabledOverride);
          setMyConnectUrl(product.url);
        }
      })
    }
  },[appProducts]);


  const onThemeChange = (e) => {
    try {
      const checked = e.target.checked;
      const newColorScheme = checked ? "dark" : "light";
      document.documentElement.setAttribute("data-color-mode", newColorScheme);
      setColorScheme(newColorScheme);
      localStorage.setItem("color-scheme", newColorScheme);
    } catch (e) {
      console.error(e);
    }
  };

  const isActive = (path) => location.pathname === path;

  const goToUrlHandler = (url, event) => {
    event.preventDefault();
    window.location.href = url;
  }

  const onViewSiteClick = (e) => {
    e.preventDefault();
    const origin = window.location.origin;
		setTimeout(function () {
			window.open(`${origin}/course/listing`, '_blank');
		}, 500);
  };

  const handlelogout = (e) => {
    e.preventDefault();
    const origin = window.location.origin;
    clearSPAuthTokens('SPAUTH_');
    if (preview_as_user === "preview_as_user") {
      window.location.assign(`${origin}/logout/admin_as_user/`);
    }
    else {
      window.location.assign(`${origin}/logout`);
    }
  }

  const onLangChange = (e) => {
    i18n.changeLanguage(e.target.value);
    setLangInCache(e.target.value);
  };

  return (
    <div className={`${className || ""} offcanvas-menu-wrapper myk__stu-offcanvas-menu-container`}>
      <div className="offcanvas-menu-header d-flex gap-3 align-items-center">
        <div className="offcanvas-menu-close" onClick={onHamburgerClick}>
          {menuCloseIcon}
        </div>
        {renderLogo ? (
        <Link className="navbar-brand" to={window.location.origin}>
          <img src={renderLogo} width="150" alt="Logo" onError={(e) => e.target.src = renderLogo} />
        </Link>
        ) : (
        <span className="no-navbar-brand">
          <Skeleton width={"100px"} height={"30px"}/>
        </span>
        )}
      </div>
      <div className="offcanvas-user-profile d-flex align-items-center justify-content-between gap-3">
        <div className="d-flex align-items-center gap-3">
          <CircleImage className="circle-wrap circle-wrap-md bg-circle-primary text-white">
            {profileImage}
          </CircleImage>
          <span className="profile-title">{adminData.us_name}</span>
        </div>
      </div>
      <div className="menu-list-wrapper">
        <Button variant="text-icon" className="btn-explore text-icon bg-transparent" type="button" onClick={onViewSiteClick}>
          Explore Courses
        </Button>
        <hr className="dropdown-divider" />
        <ul>
          <li className={isActive("/student-dashboard/") ? "active" : ""}>
            <Link to="/student-dashboard/" onClick={onHamburgerClick}>
              {homeIcon} 
              <span>{`${t("Dashboard")}`}</span>
            </Link>
          </li>
          {(showCourses === true) && 
          <li className={isActive("/student-dashboard/courses/") ? "active" : ""}>
            <Link to="/student-dashboard/courses/" onClick={onHamburgerClick}>
              {coursesIcon} 
              <span>{`${t("Courses")}`}</span>
            </Link>
          </li>}
          {(showTms === true) &&
          <li className={isActive("/student-dashboard/events") ? "active" : ""}>
            <Link to="/student-dashboard/events/" onClick={onHamburgerClick}>
              {calendarsIcon} 
              <span>{`${t("Events")}`}</span>
            </Link>
          </li>}
          {(showCourses === true) &&
          <li className={isActive("/student-dashboard/bundles") ? "active" : ""}>
            <Link to="/student-dashboard/bundles/" onClick={onHamburgerClick}>
              {bundleBoxIcon} 
              <span>{`${t("Bundles")}`}</span>
            </Link>
          </li>}
          {(showApprenticeship === true) &&
          <li className={isActive("/apprentice") ? "active" : ""}> 
            <Link to="/student-dashboard/apprentice/" onClick={goToUrlHandler.bind(true, `${ePortfolio?.url}learner/program`)}>
              {apprenticeIcon} 
              <span>{`${t("Apprentice")}`}</span>
            </Link>
          </li>}
          {(showDocumentManager === true) &&
          <li className={isActive("/documents") ? "active" : ""}>
            <Link to="/student-dashboard/dms/" onClick={onHamburgerClick}>
              {documentIcon} 
              <span>{`${t("Documents")}`}</span>
            </Link>
          </li>}
          {(showMyConnect === true) && 
          <li className={isActive("/myconnect") ? "active" : ""}>
            <Link to="/student-dashboard/myconnect/" onClick={goToUrlHandler.bind(true, myConnectUrl)}>
              {laptopIcon} 
              <span>{`${t("Myconnect")}`}</span>
            </Link>
          </li>}
          <li className={isActive("/archive") ? "active" : ""}>
            <Link to="/student-dashboard/archive/" onClick={onHamburgerClick}>
              {archiveIcon} 
              <span>{`${t("Archive")}`}</span>
            </Link>
          </li>
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li>
            <div className="d-grid align-items-center mode-switcher">
              {moonIcon}
              <span className="mx-1">{t("Dark")}</span>
              <label className="form-switch">
                <input
                  type="checkbox"
                  data-testid="themeswitcher"
                  checked={colorScheme === "dark"}
                  onChange={onThemeChange}
                />
                <span className="form-switch-slider"></span>
              </label>
            </div>
          </li>
          <li className={isActive("/message") ? "link-messages active" : "link-messages"}>
            <OffcanvasMessages
              triggerTitle={chatIcon}
              triggerSubTitle={'Messages'}
              messageCount={messageCount}
              setMessageCount={setMessageCount}
            />
          </li>
          <li className={isActive("/settings") ? "active" : ""}>
            <Link to="/student-dashboard/learner-profile" onClick={onHamburgerClick}>
              {userIcon}
              <span>{`${t("Learner Profile")}`}</span>
            </Link>
          </li>
          <li className={isActive("/settings") ? "active" : ""}>
            <Link to="/student-dashboard/settings" onClick={onHamburgerClick}>
              {settingsIcon}
              <span>{`${t("Settings")}`}</span>
            </Link>
          </li>
          <li className="sm-lang-select-item">
            {globeIcon}
            <Form.Select
              className="p-2 w-auto"
              data-testid="langselect"
              value={i18n.language}
              onChange={onLangChange}
            >
              {availableLanguages.map((lang, i) => (
                <option key={i} value={lang.value}>
                  {lang.label}
                </option>
              ))}
            </Form.Select>
          </li>
          <li className={isActive("/logout") ? "active" : ""}>
            <Link to="/student-dashboard/logout" onClick={handlelogout}>
              {logoutIcon} 
              <span>{` ${t("Log_out")}`}</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default OffcanvasNavMenu;
